import { Tooltip } from '@mui/material';
import { IconButtonLink } from './ButtonLink';
import { EditIcon } from '../../icons';
import { LinkOptions } from '@tanstack/react-router';
import { ReactNode } from 'react';

export interface EditIconButtonProps extends LinkOptions {
  title?: ReactNode;
}

export function EditIconButton({ title, ...props }: EditIconButtonProps) {
  return (
    <Tooltip title={title}>
      <IconButtonLink size="small" {...props}>
        <EditIcon />
      </IconButtonLink>
    </Tooltip>
  );
}
